<template>
    <div>
      <h2 class="text-1xl font-bold text-gray-700">
        Configuración de tipo de productos
      </h2>
      <MainTypeOfProducts />
    </div>
  </template>
  
  <script>
  import MainTypeOfProducts from "@/components/Store/TypeOfProducts/MainTypeOfProducts.vue";
import { useRoute } from 'vue-router';
import { onBeforeMount, onMounted } from 'vue';
import { findSubmoduleIdByDescription } from '@/hisAcces';
  export default {
    name: "TypeOfProducts",
    components: {
      MainTypeOfProducts,
    },
  setup() {
    const route = useRoute();
    onBeforeMount(() => {
      if (!findSubmoduleIdByDescription(route.path)) {
        window.location.href = "/login";
      }
    });

    onMounted(() => {
      document.title =
        route.meta.title + process.env.VUE_APP_TITLE ||
        process.env.VUE_APP_TITLE;
    });
  },
  };
  </script>
  